<template>
    <app-tabela
        :itens="eventosLista"
        :campos="campos"
        :itensPorPagina="itensPorPagina"
        :mostrarFiltro="false"
        :bordered="false"
        :small="false">
        <template slot="nomeEvento" slot-scope="data">
            {{data.nomeEvento }}
        </template>
        <template slot="situacao" slot-scope="data">
            <app-status
                :status="data.situacao.toUpperCase()"
            ></app-status>
        </template>
        <template slot="botoes">
            <slot name="botoes"></slot>
        </template>
        <template slot="acoes" slot-scope="data">
            <btn-atualizar-evento
                v-if="permiteInserirAtualizarEventos"
                :dataServicos="dataServicos"
                :tipo="operacao"
                :acao="acao"
                :evento="data"
                @atualizarLista="atualizarEventos()"
                @atualizarErros="$emit('atualizarErros', $event)"
            ></btn-atualizar-evento>
            <btn-cancelar-evento
                v-if="permiteCancelarEventos"
                :dataServicos="dataServicos"
                :evento="data"
                :acao="acao"
                @atualizarLista="atualizarEventos()">
            </btn-cancelar-evento>
            <documentos-evento
                :dataServicos="dataServicos"
                v-if="temAcessoDocumentosEvento"
                :evento="data"
                :acao="acao"
                :permiteInserirCancelarDocumentosEvento="permiteInserirCancelarDocumentosEvento"
                @atualizarLista="atualizarEventos()">
            </documentos-evento>
            <metas
                v-if="temAcessoMetas"
                :dataServicos="dataServicos"
                :permiteInserirMetas="permiteInserirMetas"
                :permiteCancelarMetas="permiteCancelarMetas"
                :evento="data"
                :acao="acao"
                @atualizarLista="atualizarEventos()">
            </metas>
            <slot name="acoes" v-bind="data"></slot>
        </template>
    </app-tabela>
</template>

<script>
import BtnAtualizarEvento from './BtnAtualizarEvento'
import BtnCancelarEvento from './BtnCancelarEvento'
import DocumentosEvento from './DocumentosEvento'
import Metas from './metas/Metas'

export default {
    components: {
        BtnAtualizarEvento,
        BtnCancelarEvento,
        DocumentosEvento,
        Metas
    },

    props: {
        eventos: {
            type: Array,
            default: () => []
        },

        operacao: {
            type: String,
            default: () => 'D'
        },

        acao: {
            type: Object,
            default: () => ({})
        },

        dataServicos: {
            type: Object
        },

        permiteCancelarEventos: {
            type: Boolean,
            default: () => false
        },

        temAcessoDocumentosEvento: {
            type: Boolean,
            default: () => false
        },

        temAcessoMetas: {
            type: Boolean,
            default: () => false
        },

        permiteInserirMetas: {
            type: Boolean,
            default: () => false
        },

        permiteCancelarMetas: {
            type: Boolean,
            default: () => false
        },

        permiteInserirAtualizarEventos: {
            type: Boolean,
            default: () => false
        },
        

        permiteInserirCancelarDocumentosEvento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            campos: [
            
                {
                    key: 'nomeEvento',
                    label: 'Nome da Meta',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5,
            eventosLista: []
        }
    },

    methods: {
        atualizarEventos() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterEventosPorAcao(
                this.acao.idAcaoPlanoTrabalho)
                .then(response => {
                if (response) {
                    if (response.success) {
                        this.eventosLista = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter os eventos da ação.',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    mounted(){
        if(this.eventos){
            this.eventosLista = this.eventos
            
        }
    },

    watch: {
        eventos() {
            this.eventosLista = this.eventos
        }
    }
}
</script>
